export const BREAKPOINTS = {
  mobile: 768, // ≤768px
  tablet: 1024, // ≤1024px（包含平板）
  desktop: 1025, // >1024px
};

// 判断是否为桌面端（>1024px）
export const isDesktop = () => {
  return window.innerWidth > BREAKPOINTS.tablet;
};

// 判断是否为平板（769px ~ 1024px）
export const isTablet = () => {
  return window.innerWidth > BREAKPOINTS.mobile && window.innerWidth <= BREAKPOINTS.tablet;
};

// 判断是否为移动端（≤768px）
export const isMobile = () => {
  return window.innerWidth <= BREAKPOINTS.mobile;
};
